
import { Component, inject, input, OnInit, output, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { TemplateController, TemplateEntity } from '@domain';
import { debounceTime } from 'rxjs';
import { RaEmptyComponent } from '../ra-empty/ra-empty.component';
import { RaFilletComponent } from '../ra-fillet/ra-fillet.component';
import { RaInputComponent } from '../ra-input/ra-input.component';
import { RaLoadingComponent } from '../ra-loading/ra-loading.component';
import { RaModalComponent } from '../ra-modal/ra-modal.component';

@Component({
    selector: 'ra-modal-list-templates',
    templateUrl: 'ra-modal-list-templates.component.html',
    styleUrl: 'ra-modal-list-templates.component.scss',
    imports: [
    ReactiveFormsModule,
    RaModalComponent,
    RaLoadingComponent,
    RaEmptyComponent,
    RaInputComponent,
    RaFilletComponent,
    TranslatePipe,
],
})
export class RaModalListTemplatesComponent implements OnInit {
    public message = input<string>();
    public close = output();
    public selectTemplate = output<TemplateEntity>();
    public loading = signal(true);
    public templates = signal<TemplateEntity[]>([]);
    public templatesFiltered = signal<TemplateEntity[]>([]);
    public searchControl = new FormControl('');

    // * [Injects]
    private _templateController = inject(TemplateController);

    ngOnInit(): void {
        this._getTemplates();
        this._listenSearchControl();
    }

    private _getTemplates(): void {
        this.loading.set(true);
        this._templateController.getAll().subscribe({
            next: templates => {
                this.templates.set(templates);
                this.templatesFiltered.set(templates);
                this.loading.set(false);
            },
            error: () => this.loading.set(false),
        });
    }

    private _filterTemplates(): void {
        const searchValue = this.searchControl.value?.toLowerCase().trim() || '';

        if (!searchValue) {
            this.templatesFiltered.set(this.templates());
            return;
        }

        this.templatesFiltered.set(
            this.templates().filter(template => template.title?.toLowerCase().includes(searchValue))
        );
    }

    private _listenSearchControl(): void {
        this.searchControl.valueChanges
            .pipe(debounceTime(600))
            .subscribe(() => this._filterTemplates());
    }
}
